import { z } from 'zod';
import { I18nStringSchema } from '../../core/i18n';
export const RemedyPairSchema = z.object({
    baseRemedy: z.string(),
    pairedRemedy: z.string(),
    pairingDescriptionI18n: I18nStringSchema
});
//# sourceMappingURL=remedyPairings.js.map